"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPreferredVideoCodecsToVideoCodecCapabilities = void 0;
const amazon_chime_sdk_js_1 = require("amazon-chime-sdk-js");
const codecMap = {
    vp9: amazon_chime_sdk_js_1.VideoCodecCapability.vp9,
    vp8: amazon_chime_sdk_js_1.VideoCodecCapability.vp8,
    h264: amazon_chime_sdk_js_1.VideoCodecCapability.h264,
};
/**
 * Returns an array of [[VideoCodecCapability]] objects that are the preferred codecs
 * of most preferred to least preferred.
 *
 * When providing multiple codec preferences, the service automatically selects the most preferred codec that all session attendees can decode.
 *
 * For more information on codecs, see: https://aws.github.io/amazon-chime-sdk-js/modules/videocodecs.html#setting-video-send-codec-preferences
 * and https://docs.aws.amazon.com/chime-sdk/latest/dg/js-meeting-manage-codecs.html
 *
 * @param String of codecs to prefer
 */
function convertPreferredVideoCodecsToVideoCodecCapabilities(preferredVideoCodecs) {
    const videoCapabilities = [];
    preferredVideoCodecs.split(',').forEach(codec => {
        const codecFactory = codecMap[codec.trim().toLowerCase()];
        if (codecFactory) {
            videoCapabilities.push(codecFactory());
        }
    });
    return videoCapabilities;
}
exports.convertPreferredVideoCodecsToVideoCodecCapabilities = convertPreferredVideoCodecsToVideoCodecCapabilities;
//# sourceMappingURL=chime_codec_helper.js.map